import Vue from 'vue';
import { createUUIDv4 } from '../util/helpers';
import { eventBus } from '../util/eventbus';
import { toastMessage, clearAllToasts } from '../components/_ui/_utils/useEventUtils'

export const ApckFlashComponent = {
    props: {
        uuid: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'success',
        },
        errors: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        close() {
            this.$emit('close', this.uuid);
        },
    },
    computed: {
        flashStyle() {
            return `flash-${this.type}`;
        },
    },
    template: `
    <div :class="['flash', flashStyle]" :data-id="uuid">
        <span class="flash-close" v-on:click="close">
            <i class="fa fa-close"></i>
        </span>
        <p>{{message}}</p>
        <ul v-if="errors.length > 0">
            <li v-for="error, index in errors" :key="index">{{error}}</li>
        </ul>
    </div>`,
};

export const ApckFlashHolder = {
    components: {
        ApckFlashComponent,
    },
    created() {},
    data() {
        return {
            container: [],
        };
    },
    methods: {
        addFlash(options) {
            const cmp = this;

            const defaults = {
                uuid: createUUIDv4(),
                type: 'success',
                message: '',
                hideTimeout: 40000,
                // target: null,
                // template: "",
                // autoOpen: true,
                errors: [],
            };

            const flashOptions = Object.assign(defaults, options);
            flashOptions.timeout = setTimeout(() => {
                cmp.removeFlash(flashOptions.uuid);
            }, flashOptions.hideTimeout);
            cmp.container = [];
            cmp.container.push(Object.assign(flashOptions));
        },
        removeFlash(uuid) {
            const index = this.container.findIndex((f) => f.uuid === uuid);
            if (index === -1) return;
            clearTimeout(this.container[index].timeout);
            this.container.splice(index, 1);
        },
        removeAll() {
            this.container.forEach((element) => {
                this.removeFlash(element.uuid);
            });
        },
    },
    mounted() {
        eventBus.$on('flash:new', this.addFlash);
        eventBus.$on('flash:clearAll', this.removeAll);
    },
    template: `
    <div class="flash-holder">
        <transition-group name="flash-fade">
            <apck-flash-component
                v-for="item in container"
                :uuid="item.uuid"
                :key="item.uuid"
                :message="item.message"
                :type="item.type"
                :errors="item.errors"
                v-on:close="removeFlash"
            />
        </transition-group>
    </div>
    `,
};

export const flashMessage = (options) => {
    toastMessage(options)
};

// plugin
const ApckFlash = {};

ApckFlash.install = (Vue) => {
    Vue.component('apck-flash-holder', ApckFlashHolder);
    Vue.prototype.$flash = (options) => {
        toastMessage(options)
    };
    Vue.prototype.$clearAllFlashes = () => {
        clearAllToasts()
    };
};

export default ApckFlash;
